"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultResultTableTranslate = void 0;
exports.defaultResultTableTranslate = {
    building: 'Building',
    price: 'Price',
    ppsfsa: '$/SF(S)',
    ppsfgfa: '$/SF(G)',
    ppsf: '$/SF',
    size: 'Size',
    sizeSa: 'Size(S)',
    sizeGfa: 'Size(G)',
    gfa: '(G)',
    sa: '(S)',
    beds: 'Beds',
    baths: 'Baths',
    date: 'Date',
    contact: 'Contact',
    subjectToOffer: '-',
    sqft: 'SF',
    forRent: 'For Rent',
    forSale: 'For Sale',
};
